'use strict';

angular.module('amexReconciliationApp')
  .service('ErrorMessageService',
  function ErrorMessageService() {
    var NO_ERRORS = null;

    this.chooseErrorMessage = function chooseErrorMessage(errors, messages){
      if (!errors) {
        return NO_ERRORS;
      }

      for (var errorCode in messages) {
        if (errors[errorCode]) {
          return messages[errorCode];
        }
      }

      return NO_ERRORS;
    };

  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/ErrorMessageService.js
// module id = 636
// module chunks = 0